import { render, staticRenderFns } from "./TraceabilityModal.vue?vue&type=template&id=cbb5a2ca&"
import script from "./TraceabilityModal.vue?vue&type=script&lang=js&"
export * from "./TraceabilityModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cbb5a2ca')) {
      api.createRecord('cbb5a2ca', component.options)
    } else {
      api.reload('cbb5a2ca', component.options)
    }
    module.hot.accept("./TraceabilityModal.vue?vue&type=template&id=cbb5a2ca&", function () {
      api.rerender('cbb5a2ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/traceability/TraceabilityModal.vue"
export default component.exports